"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  accountingMonitor: {
    my: 'My',
    draft: 'Draft',
    submit: 'Submitted',
    businessApprove: 'Business approving',
    localApprove: 'Local financial approving',
    fiApprove: 'Share center approving',
    Approved: 'Approved',
    awaitPay: 'Waiting payment',
    businessReject: 'Business rejected',
    localReject: 'Local financial rejected',
    fiReject: 'Share center rejected',
    awaitAdjust: 'Waiting for change the payment information',
    processingInfo: 'The processing of local financial historical payment',
    processingInfoTip: 'Pie chart shows the payment processing after the payments is transferred to the local finance',
    date: 'Date：',
    to: 'To',
    startDate: 'Start Date',
    endDate: 'End Date',
    processedSum: 'The number of \n payments',
    order: 'Order',
    day: 'day',
    days: 'days',
    over7Days: 'Over 7 days',
    localFiProcess: 'Local financial payments to be processed',
    localFiProcessTip: 'The histogram shows the number of unhandled payment requisitions per unit day after the business is approved and transferred to the local finance.',
    localFiProcess2: 'Local financial payments to be processed (business approved)',
    localFiProcessTip2: 'The histogram shows the number of payment requisitions approved per unit day after the business is approved and transferred to the local finance.',
    mine: 'Mine',
    all: 'All',
    paidUnmarkedInvoice: 'Paid but not marked invoice to complete the order.',
    paidUnmarkedInvoiceTip: 'The bar chart shows the paid requisition, and the number of payment orders not marked with full invoice.',
    monthArray: 'One month,Two months,Three months,Four months,Five months,Six months,Over half of a year',
    overOneMonth: 'Amount due for more than one month',
    inOneMonth: 'Amount due within one month',
    expired: 'Expired',
    creditNoteStatistics: 'Credit note statistics',
    creditNoteStatisticsTip: 'Pie chart shows the unwritten off status of the current credit note.',
    creditNoteSum: 'The total amount of \n credit note.'
  }
};